import Text from "@/components/Text";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDelete: () => void;
};

const DialogDeleteGrid: FC<Props> = ({ open, onOpenChange, onDelete }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            <Text fontSize={24} fontWeight={500} color="#414651">
              {t("delete_grid_title")}
            </Text>
          </DialogTitle>
        </DialogHeader>
        <DialogDescription className="flex flex-col">
          <Text fontSize={16} fontWeight={400} color="#414651">
            {t("delete_grid_description_1")}
          </Text>
          <Text fontSize={16} fontWeight={400} color="#414651">
            {t("delete_grid_description_2")}
          </Text>
        </DialogDescription>
        <DialogFooter className="flex sm:justify-start">
          <Button variant="secondaryFilled" onClick={() => onOpenChange(false)}>
            {t("cancel")}
          </Button>
          <Button style={{ width: "calc(100% - 90px)" }} onClick={onDelete}>
            {t("delete_grid_button")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DialogDeleteGrid;
